import { CommandParser } from '../client/parser';
import { NumberReply, Command, RedisArgument } from '../RESP/types';
import { RedisVariadicArgument } from './generic-transformers';

export default {
  parseCommand(parser: CommandParser, key: RedisArgument, values: RedisVariadicArgument) {
    parser.push('ARINSERT');
    parser.pushKey(key);
    parser.pushVariadic(values);
  },
  transformReply: undefined as unknown as () => NumberReply
} as const satisfies Command;
